import { Link, usePage, Head } from '@inertiajs/react';
import React from 'react';
import useRoute from '@/Hooks/useRoute';
import AppTextLogo from '@/Components/Utility/AppTextLogo';
import { motion } from 'framer-motion';

export default function Welcome({ canLogin, profiles }) {
  const route = useRoute();
  const page = usePage();

  const animateCard = {
    initial: { rotate: 0, scale: 1 },
    animate: { rotate: 6, scale: 1.05 },
    exit: { rotateY: 0, scale: 1, transition: { duration: 0.3 } },
  };

  return (
    <div className="items-top relative flex min-h-screen justify-center sm:items-center sm:pt-0">
      <Head>
        <title>Profile Links</title>
        <meta
          name="description"
          content={`Profile Links - Transform your digital performance`}
        />
        <meta
          name="keywords"
          content="graphic design, web developer, developer, leeds design, leeds developer, leeds laravel, leeds vue, design studio, design studio leeds"
        />
        <meta property="og:url" content={window.location.href} />
        <link rel="alternate" href="https://madeby.studio" hreflang="en-GB" />
        <meta property="og:site_name" content="madeby.studio - Profiles" />
        <meta name="twitter:title" content={`Profile Links | madeby.studio`} />
        <meta
          name="twitter:description"
          content={`Profile Links Links - Transform your digital performance`}
        />

        <meta property="og:title" content={`Profile Links | madeby.studio`} />
        <meta
          property="og:description"
          content={`Profile Links Links - Transform your digital performance`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en-GB" />
        <meta
          property="og:image"
          content="https://madeby.studio/assets/branding/meta-opengraph.png"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image:alt"
          content="madeby.studio - Team Working and Strapline"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:image"
          content="https://madeby.studio/assets/branding/twitter-opengraph.png"
        />
        <meta name="twitter:site" content="@madebystudio" />
        <meta name="twitter:creator" content="@madebystudio" />
      </Head>
      {canLogin ? (
        <div className="fixed top-0 right-0 z-front px-6 py-4 sm:block">
          {page.props.user && (
            <Link
              href={route('links.show')}
              className="text-sm font-bold uppercase tracking-wider opacity-25 duration-default hover:cursor-pointer hover:opacity-100"
            >
              Dashboard
            </Link>
          )}
        </div>
      ) : null}
      <div className="flex w-full flex-col px-8 md:max-w-screen-xl md:px-0">
        <div className="mt-12 flex w-full flex-col items-center px-8 text-center">
          <AppTextLogo style="dark" />
          <h1 className="mt-8 text-4xl leading-tight text-dark md:mt-auto md:text-5xl">
            Meet the team<span className="text-primary">.</span>
          </h1>
          <p className="text-grey md:-mt-4">
            Click on a team member to connect with them.
          </p>
        </div>
        <div className="mt-20 flex w-full flex-col break-words px-4 pb-12 sm:px-8">
          <div className="justify-self mt-4 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {profiles.map((profile, index) => {
              return (
                <Link
                  href={route('linksProfile.show', profile.profile_slug)}
                  key={profile + index}
                  className="col-span-2 flex w-full justify-center sm:col-span-1"
                >
                  <div className="group relative flex h-full flex-col justify-end">
                    <motion.div
                      className="aspect-square h-auto w-full text-dark duration-mini"
                      variants={animateCard}
                      initial="initial"
                      whileHover="animate"
                      exit="exit"
                    >
                      <img
                        src={profile.profile_photo_url}
                        className="relative  top-0 left-0 aspect-square h-full w-full origin-center rounded-full object-cover duration-mini hover:shadow-sm "
                      />
                    </motion.div>
                    <div className="relative z-front mt-4 flex flex-col items-center">
                      <h5 className="relative z-front flex text-xl font-medium text-dark">
                        {profile.name}
                        <span className="absolute right-0 -mr-6 text-3xl text-primary duration-default group-hover:translate-x-1">
                          &#8605;
                        </span>
                      </h5>
                      <p className="text-base opacity-50">
                        {profile.user_role}
                      </p>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
